import { Reducer } from "redux";

import { NoteListDetailsResponse } from "../models/Api/AuthorizationDetailsTab";
import { NotesListDispatchTypes } from "../models/DispatchTypes/AuthorizationDetailstab";
import { NotesListActionDispatchTypes } from "../constants/Authorization";

const initialState: NoteListDetailsResponse = {
    loading: false,
    response: [],
    error: null,
};

const NotesListReducer: Reducer<
    NoteListDetailsResponse,
    NotesListDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case NotesListActionDispatchTypes.NOTES_LIST_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case NotesListActionDispatchTypes.NOTES_LIST_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
        case NotesListActionDispatchTypes.NOTES_LIST_ERROR: {
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        }
        case NotesListActionDispatchTypes.NOTES_LIST_RESET: {
            return initialState;
        }
    }
    return state;
};
export default NotesListReducer;
